import { Store } from '../../../store/list/types';

export const openAndFocusAddFilter = (store: Store): void => {
  const { addFilterTippyInstance } = store.getState();

  if (addFilterTippyInstance) {
    addFilterTippyInstance.open();
  }
};
